import PropTypes from 'prop-types';

const MicOffIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill={fill}>
      <g fill={fill} fillRule="evenodd">
        <path
          d="M39.882 18C41.052 18 42 19.002 42 20.238c0 9.672-6.82 17.658-15.652 18.874v4.524h3.13c1.153 0 2.087.977 2.087 2.182S30.631 48 29.478 48H19.043c-1.152 0-2.086-.977-2.086-2.182s.934-2.182 2.086-2.182h3.13v-4.46a17.244 17.244 0 0 1-7.55-2.686l3.224-3.225A13.103 13.103 0 0 0 24 34.796c7.603 0 13.765-6.517 13.765-14.558 0-1.236.948-2.238 2.117-2.238zM33 18.112v2.238c0 5.327-4.035 9.65-9 9.65a8.44 8.44 0 0 1-2.507-.38L33 18.113zM8.118 18c1.17 0 2.117 1.002 2.117 2.238 0 1.919.351 3.75.988 5.428l-3.249 3.249A19.843 19.843 0 0 1 6 20.238C6 19.002 6.948 18 8.118 18zM24 0c3.399 0 6.357 2.02 7.889 5.001l-16.79 16.79A10.392 10.392 0 0 1 15 20.356V9.637C15 4.317 19.035 0 24 0z"
          fillRule="nonzero"
        />
        <path d="M4.595 36.86 40.387 1.066c.59-.59 1.544-.59 2.134 0l.237.237c.589.589.589 1.544 0 2.133L6.965 39.23c-.59.589-1.544.589-2.133 0l-.237-.237a1.508 1.508 0 0 1 0-2.134z" />
      </g>
    </svg>
  </div>
);

MicOffIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

MicOffIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default MicOffIcon;
